import React from "react";
import { Box, Typography } from "@material-ui/core";
const DiscoveryDescription = () => (
  <Box>
    <Typography gutterBottom variant="body2">
      Discovery practices start with the current as-is state and help you ask
      important questions about outcomes.
    </Typography>
    <Typography variant="body2">
      <i>
        Why are you doing this? What problems are you trying to solve, and for
        whom? How will you measure the results?
      </i>
    </Typography>
  </Box>
);
export default DiscoveryDescription;
